import { CheckCircle } from "@phosphor-icons/react";

import useAllPricing from "features/subscriptions/datahooks/useAllPricing";

import { Tag } from "common/components/ui/Tag";

import { BILLING_STATUSES } from "../../constants";
import { formatBillingDate } from "../../utils";
import DownloadInvoice from "./DownloadInvoice";

import type { Invoice } from "../../types";

export default function MobileList({ invoices }: { invoices: Invoice[] }) {
  const { allPricing } = useAllPricing();

  return (
    <section className="flex flex-col gap-2.5">
      {invoices.map((invoice) => {
        const { date, total, status, id, line_items: lineItems } = invoice;

        const mainLineItem = lineItems.find(
          ({ entity_type }) => entity_type === "plan_item_price",
        );
        const seatsLineItem = lineItems.find(
          ({ entity_type }) => entity_type === "addon_item_price",
        );

        let paymentPeriod = "One time payment";

        if (mainLineItem && allPricing) {
          const pricingPlan = allPricing.find(
            (plan) => plan.id === mainLineItem.entity_id,
          );
          if (pricingPlan) {
            paymentPeriod =
              pricingPlan.period_unit === "month"
                ? "Monthly subscription"
                : "Yearly subscription";
          }
        }
        // line items can be an empty array
        let plan = "-";
        if (lineItems.length) {
          const adhocLineItem = lineItems.find(
            ({ entity_type }) => entity_type === "adhoc",
          );
          plan =
            mainLineItem?.description ||
            seatsLineItem?.description ||
            adhocLineItem?.description;
        }

        return (
          <div
            key={id}
            className="flex flex-col rounded-3xl border border-black-200 p-2"
          >
            <div className="flex flex-row items-center justify-between rounded-lg bg-black-100 p-2">
              <span className="text-xs-bold text-black-700">
                {formatBillingDate(date * 1000)}
              </span>

              <DownloadInvoice invoiceId={id} />
            </div>
            <div className="flex flex-col p-2">
              <div className="flex flex-1 items-center gap-x-2.5 border-b border-b-black-200 pb-2.5">
                <div className="flex flex-1 flex-col">
                  <span className="text-sm-bold text-black-700">{plan}</span>
                  <span className="text-xs text-black-400">
                    {paymentPeriod}
                  </span>
                </div>
                <Tag
                  variant="tertiary"
                  size="sm"
                  leftIcon={
                    status === "paid" && (
                      <CheckCircle className="text-green-500" weight="fill" />
                    )
                  }
                >
                  {BILLING_STATUSES[status].label}
                </Tag>
              </div>
              <div className="flex pt-2.5">
                <div className="flex flex-1 flex-col gap-y-1 text-black-700">
                  <span className="text-xs">Number of seats</span>
                  <span className="text-xs-bold">
                    {seatsLineItem ? seatsLineItem.quantity : "-"}
                  </span>
                </div>
                <div className="flex flex-1 flex-col gap-y-1 text-black-700">
                  <span className="text-xs">Amount</span>
                  <span className="text-xs-bold">${total}</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
}
